import React, { useState, useEffect } from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import ConnectZoomButton from 'components/shared/ConnectZoomButton';
import ZoomContext from 'components/InPersonTraining/shared/ZoomContext';
import { Button } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import ZoomLogo from 'images/zoom_logo.svg';
import DisconnectZoomConfirmationModal from './DisconnectZoomConfirmationModal';

const SettingsZoomIntegration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [disconnectError, setDisconnectError] = useState(false);

  const [currentUser, setCurrentUser] = useState('');
  const [currentCompany, setCurrentCompany] = useState('');
  const [zoomClientId, setZoomClientId] = useState('');
  const [
    zoomOauthIntegrationExternalUsername,
    setZoomOauthIntegrationExternalUsername,
  ] = useState('');
  const [zoomOauthIntegrationId, setZoomOauthIntegrationId] = useState(false);
  const [userHasEasToken, setUserHasEasToken] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  function fetchMyAccount() {
    setLoading(true);
    request
      .get(routes.SETTINGS.MY_ACCOUNT)
      .then(payload => {
        setCurrentUser(payload.currentUser);
        setCurrentCompany(payload.currentCompany);
        setZoomClientId(payload.zoomIntegration?.zoomClientId);
        setZoomOauthIntegrationExternalUsername(
          payload.zoomIntegration?.zoomOauthIntegrationExternalUsername,
        );
        setZoomOauthIntegrationId(
          payload.zoomIntegration?.zoomOauthIntegrationId,
        );
        setUserHasEasToken(payload.userHasEasToken);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchMyAccount();
  }, []);

  function handleDisconnect() {
    setButtonDisabled(true);
    request
      .delete(routes.USER_INTEGRATION(currentUser?.id, zoomOauthIntegrationId))
      .then(() => {
        fetchMyAccount();
        setButtonDisabled(false);
        setShowModal(false);
      })
      .catch(e => {
        console.error(e);
        setButtonDisabled(false);
        setDisconnectError(e.responseJSON);
      });
  }

  return (
    <>
      {!loading && (
        <>
          <>
            {zoomOauthIntegrationId ? (
              <>
                <img
                  className="h-34 mb-16"
                  src={ZoomLogo}
                  alt={t('in_person_training.events.zoom_logo')}
                />
                <Text className="d-f my-16 mb-8" variant={TEXT_VARIANTS.BODY}>
                  {zoomOauthIntegrationExternalUsername
                    ? t('settings.tab.my_account.zoom_email_connected', {
                        external_username: zoomOauthIntegrationExternalUsername,
                      })
                    : t('settings.tab.my_account.zoom_account_connected')}
                </Text>
                <Button
                  customColor
                  className="mr-4"
                  disabled={isButtonDisabled}
                  onClick={() => setShowModal(true)}
                >
                  {t('common.disconnect')}
                </Button>
                <ZoomContext.Provider value={{ zoomClientId }}>
                  <ConnectZoomButton
                    currentUser={currentUser}
                    currentCompany={currentCompany}
                    zoomOauthIntegrationId={zoomOauthIntegrationId}
                    userHasEasToken={userHasEasToken}
                    loading={loading}
                  />
                </ZoomContext.Provider>
                <>
                  {showModal && (
                    <DisconnectZoomConfirmationModal
                      closeModal={() => {
                        setShowModal(false);
                        setDisconnectError(false);
                      }}
                      disconnectZoom={handleDisconnect}
                      error={disconnectError}
                    />
                  )}
                </>
              </>
            ) : (
              <ZoomContext.Provider value={{ zoomClientId }}>
                <img
                  className="h-34 mb-16"
                  src={ZoomLogo}
                  alt={t('in_person_training.events.zoom_logo')}
                />
                <Text className="d-f mb-16" variant={TEXT_VARIANTS.BODY}>
                  {t('settings.tab.my_account.integrate_with_zoom')}
                </Text>
                <ConnectZoomButton
                  currentUser={currentUser}
                  currentCompany={currentCompany}
                  zoomOauthIntegrationId={zoomOauthIntegrationId}
                  userHasEasToken={userHasEasToken}
                  loading={loading}
                />
              </ZoomContext.Provider>
            )}
          </>
          <>
            {error && (
              <p className="HelpText error">
                {t('settings.tab.my_account.zoom_integration_error')}
              </p>
            )}
          </>
        </>
      )}
    </>
  );
};

export default SettingsZoomIntegration;
